import React, { memo } from 'react'
import Svg from '../svg/svg'

import * as styles from './button.module.scss'
import { ActionIconButtonProps } from './types'

const ActionButton = ({ title, action, iconId }: ActionIconButtonProps) => (
   <button type="button" className={styles.actionButton} onClick={action}>
      <div className={styles.buttonContent}>
         <div className={styles.buttonIcon}>
            <Svg id={iconId} width={40} height={40} />
         </div>
         <div className={styles.buttonText}>{title}</div>
      </div>
   </button>
)

export default memo(ActionButton)
